import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@common/button";
import { Modal } from "@common/modal";
import { useRemoveStrategicAxis } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function StrategicAxisRemoval({ cancel, strategicAxis }: Props) {
  const { t } = useTranslation();
  const { removeStrategicAxis, isRequestPending } =
    useRemoveStrategicAxis(strategicAxis);

  return (
    <Modal
      header={t("strategicAxesPage.removal.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("strategicAxesPage.removal.confirmation")}
          </p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("strategicAxesPage.removal.cancel")}
          </Button>
          <Button
            type={"delete"}
            status={isRequestPending ? "pending" : "none"}
            press={() => removeStrategicAxis(strategicAxis)}
          >
            {t("strategicAxesPage.removal.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { StrategicAxisRemoval };
